import React from "react";

export default function polygonPinIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="21.297"
      height="18.66"
      viewBox="0 0 21.297 15.66"
      style={{ ...props.style }}
    >
      <g
        id="Group_4115"
        data-name="Group 4115"
        transform="scale(0.9,0.9) translate(-1660.699 -125.898)"
      >
        <path
          id="Path_9724"
          data-name="Path 9724"
          d="M-2993.821-1575.375h-5.766l-2.882,4.993,2.882,4.993h5.766l2.882-4.993Z"
          transform="translate(4663.167 1709.272)"
          fill={props.style.color}
        />
      </g>
      <g id="Group_3675" data-name="Group 3675" transform="translate(0 0)">
      <path
          id="Path_9595"
          data-name="Path 9595"
          d="M12.5,0A12.5,12.5,0,0,1,25,12.5c0,6.9-12.5,25.735-12.5,25.735S0,19.4,0,12.5A12.5,12.5,0,0,1,12.5,0Z"
          transform= "scale(0.4,0.4) translate(26 0)"
          fill={props.style.color}
        />
        <circle
          id="Ellipse_63"
          data-name="Ellipse 63"
          cx="8.5"
          cy="8.5"
          r="8.5"
          transform= "scale(0.2,0.2) translate(68 17)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}
